module.exports = __webpack_public_path__ + "static/img/duoyuan_03.366cbf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/duoyuan_03.png
// module id = 2AaM
// module chunks = 0